import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { Auth0Provider } from '@auth0/auth0-react';
import AppRouter from './AppRouter';
import {CONFIG} from "./constants";

const root = createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <All />
);

function All() {
  const [outerRoute, setOuterRoute] = React.useState<string|undefined|null>(null);

  return (
    <Auth0Provider
      domain="zebrain.eu.auth0.com"
      clientId={CONFIG.AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: 'https://zebrain.eu.auth0.com/api/v2/',
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={
        (appState) => {
          if (appState) {
            setOuterRoute(appState.returnTo);
          }
        }
      }
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <AppRouter outerRoute={outerRoute} />
    </Auth0Provider >
  );
}
